import { BasicRequest } from "./basicRequest";

export class DeleteMoovConfigurationRequest extends BasicRequest{
    public moovConfigurationId! : number;
    public physicalDelete : boolean = false;
}